// extracted by mini-css-extract-plugin
export default {"addToCartControl":"K1-z","giftCard":"L1-z","btnContainer":"M1-z","cartButton":"N1-z","disabled":"O1-z"};